// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"53":"5215b3b0","978":"60ec2248"}[chunkId] + ".chunk.css";
};